import { RunesTable } from "./RunesTable";
import { getRunes } from "@ugg/shared/api/data-parser/champions/runes-table";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params//valid-params";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { useChampionRunes } from "@ugg/shared/api/requests/champions/runes-table";
import { ChampionProfilePagePlaceholder } from "@ugg/shared/components/Champions/ChampionProfilePagePlaceholder";
import { ChampionProfilePageError } from "@ugg/shared/components/Champions/ChampionProfilePageError";
import { normalizeRole } from "@ugg/shared/utils/role-helpers";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";

export function RunesTableContainer() {
  const { championId, role } = useChampionProfileContext();

  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(CHAMPION_PAGES.RUNES_TABLE, queryParams, true);
  const { data, loading, error } = useChampionRunes(championId, { params: validatedQueryParams, ssr: true });
  const championRunes = getRunes(data, { ...validatedQueryParams, role: normalizeRole(role || "") });

  if (loading) {
    return <ChampionProfilePagePlaceholder className="w-full" />;
  } else if (!championRunes || error) {
    return <ChampionProfilePageError className="w-full" />;
  }

  return (
    <div className="w-full overflow-x-auto">
      <RunesTable className="w-full min-w-[974px]" data={championRunes} patch={validatedQueryParams.patch} />
    </div>
  );
}
